<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">{{categoryName}}</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li class="breadcrumb-item">
                                        <router-link to="/all-categories">Categories</router-link>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">{{categoryName}}</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <section class="product-area product-area-2">
            <div class="container">
                <div class="row align-items-center pt-65 pb-20">
                    <div class="col-md-2">
                        <div class="product-grid-tab d-flex">
                            <span>{{products.length}} Products </span>
                        </div>
                    </div>
                    <div class="col-md-10">
                        <div class="product-grid-select float-left float-md-right">
                            <ul>
                                <li>
                                    <form class="form-inline" @submit.prevent="filterProducts">
                                        <div class="form-group mx-sm-3 mb-2">
                                            <v-select v-model="form.sub_category_id" label="name" :options="subcategories"
                                                      @input="filterProducts"
                                                      :reduce="sub => sub.id"
                                                      placeholder="Sort by sub-category" style="width: 300px;
                                                      background-color: #fff;"></v-select>
                                        </div>
                                        <div class="form-group mx-sm-3 mb-2">
                                            <v-select v-model="form.brand_id" label="name" :options="info"
                                                      @input="filterProducts"
                                                      :reduce="bra => bra.id"
                                                      placeholder="Sort by Brand" style="width: 230px;
                                                      background-color: #fff;"></v-select>
                                        </div>
                                        <div class="form-group mx-sm-3 mb-2">
                                            <input v-model="form.title" type="text" class="form-control"
                                                   placeholder="Search By Name">
                                        </div>
                                        <button type="submit" class="btn btn-primary mb-2"><i class="fas fa-search"></i>
                                        </button>
                                    </form>
                                </li>
                                <small style="color: red" v-if="error && errors.search">{{ errors.search[0] }}</small>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                         aria-labelledby="pills-home-tab">
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-sm-6" v-for="product in pageOfItems" :key="product.id">
                                <div class="single-product mt-30">
                                    <router-link
                                            :to="{name: 'product_details', params: {category: categoryName, productId: product.uniqueId}}">
                                        <div style="width: 255px; height: 300px; overflow: hidden">
                                            <img id="img" v-lazy="product.files[0].filePath" :alt="product.title"
                                                 style="width: 100%">
                                        </div>
                                        <h6 class="title">{{product.title}}</h6>
                                    </router-link>
                                    <span v-if="product.status == 0" style="background: red">Out of stock</span>
                                    <ul>
                                        <li>Ksh{{product.price | formatNumber}}</li>
                                    </ul>
                                </div> <!-- single product -->
                            </div>
                        </div>
                        <div class="row" v-if="products.length < 1">
                            <small class="text-danger">No products found</small>
                        </div>
                        <div class="row justify-content-center">
                            <div>
                                <jw-pagination :items="products" @changePage="onChangePage" :labels="customLabels"
                                               :pageSize="16"></jw-pagination>
                            </div>
                        </div>

                    </div>
                </div>
            </div> <!-- container -->
        </section>
    </div>
</template>

<script>
    import 'vue-select/dist/vue-select.css';

    const customLabels = {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
    };
    export default {
        name: "CategoryProducts",
        data() {
            return {
                error: false,
                errors: {},
                categoryId: this.$route.params.categoryId,
                categoryName: this.$route.params.categoryName,
                all: [],
                pageOfItems: [],
                customLabels,
                products: [],
                subcategories: [],
                form: {
                    sub_category_id: '',
                    brand_id: '',
                    title: '',
                    category_id: this.$route.params.categoryId
                },
                info: []
            }
        },
        methods: {
            filterProducts() {
                this.axios.post("/shopLocal/filter-products", this.form).then(({data}) => ([
                    this.products = data,
                    this.all = data
                ]));
            },
            getSubCategoryBrands() {
                this.axios.get('subcat_brands/' + this.categoryId).then(data => {
                    this.info = data.data
                }).catch(resp => {
                    throw new Error(resp);
                })
            },
            onChangePage(pageOfItems) {
                // update page of items
                this.pageOfItems = pageOfItems;
            },
            getCategoryProducts() {
                this.axios.get("/shopLocal/products/" + this.categoryId).then(({data}) => ([
                    this.products = data,
                    this.all = data
                ]));
            },
            getSubCategories() {
                this.axios.get("/shopLocal/sub-categories/" + this.categoryId).then(({data}) => ([this.subcategories = data]));
            }
        },
        created() {
            this.getSubCategories();
            this.getCategoryProducts();
            this.getSubCategoryBrands();
        }
    }
</script>

<style scoped>
    #img {
        object-fit: cover;
        width: 100%;
        min-height: 100%;
    }
</style>